import DSIcon from './DSIcon';

export default DSIcon;
